import { type JSX } from 'react';

import { EloIcon } from '@plurall/elo-v3';
import { useRouter } from '@tanstack/react-router';

import {
  NavActionButtonFactory,
  NavCenterFactory,
  NavEndFactory,
  NavRootFactory,
  NavStartFactory,
  NavTitleFactory,
} from '../GlobalNavigation/factories/global-navigation-factory';

type InnerPageTopBarProps = {
  title: string;
  isBack?: boolean;
  onToggle?: () => void;
  isMenuOpen?: boolean;
};

export function InnerPageTopBar({
  title,
  isBack = true,
  onToggle,
  isMenuOpen = false,
}: InnerPageTopBarProps): JSX.Element {
  const router = useRouter();

  return (
    <NavRootFactory>
      <NavStartFactory>
        {isBack ? (
          <NavActionButtonFactory
            type='button'
            aria-label='Voltar'
            onClick={() => router.history.back()}>
            <EloIcon
              icon='arrow-left'
              size='md'
            />
          </NavActionButtonFactory>
        ) : (
          <NavActionButtonFactory
            type='button'
            aria-label={isMenuOpen ? 'Fechar Menu' : 'Abrir Menu'}
            onClick={onToggle}>
            <EloIcon
              icon={isMenuOpen ? 'cancel' : 'menu-burger'}
              size='md'
            />
          </NavActionButtonFactory>
        )}
      </NavStartFactory>

      <NavCenterFactory>
        <NavTitleFactory as='span'>{title}</NavTitleFactory>
      </NavCenterFactory>

      <NavEndFactory>
        <NavActionButtonFactory
          type='button'
          aria-label='Mais opções'>
          <EloIcon
            icon='menu-dots-vertical'
            size='md'
          />
        </NavActionButtonFactory>
      </NavEndFactory>
    </NavRootFactory>
  );
}
